// CU-86d45b2zn — the one access-outcome classifier for every customer-facing Commerce call; a 401 is grouped with
// the refresh-required 403 because both are remedied only by signing in again.
import axios from "axios";

export const CUSTOMER_SESSION_REFRESH_REQUIRED = "customer_session_refresh_required";
export const CUSTOMER_ACCESS_FORBIDDEN = "customer_access_forbidden";

export type CustomerAccessOutcome = "session_refresh_required" | "forbidden" | "unavailable";

export const classifyCustomerAccessError = (error: unknown): CustomerAccessOutcome => {
	if (!axios.isAxiosError(error) || !error.response) return "unavailable";

	const { status, data } = error.response;
	const code = typeof data?.code === "string" ? data.code : undefined;

	if (status === 401) return "session_refresh_required";
	if (status === 403 && code === CUSTOMER_SESSION_REFRESH_REQUIRED) return "session_refresh_required";
	if (status === 403) return "forbidden";

	return "unavailable";
};
